module.exports = __webpack_public_path__ + "static/media/pw-coins-active-icon.4a53e691.svg";